// Brand colours. Navy and orange are the Oxide brand; the neutrals are warm
// so pages read as print rather than as a template.
export const colors = {
  navy: "#14213D",
  navyMid: "#3B4069",
  navyDeep: "#0E1730",
  orange: "#EB9B29",
  orangeDark: "#B86E00", // orange that passes contrast on white, for text
  ink: "#14213D",
  body: "#4A5168",
  muted: "#6B7184",
  paper: "#FFFFFF",
  paperWarm: "#F7F5F0",
  panel: "#EFEDE7",
  line: "#E3E0D8",
  lineDark: "rgba(255,255,255,0.12)",
  onDark: "#FFFFFF",
  onDarkMuted: "rgba(255,255,255,0.68)",
};

export const company = {
  legalName: "Oxide Digital Technology SARL",
  shortName: "Oxide Digital Technology",
  street: "21 Avenue Kabare",
  district: "Q/ Muhumba, C/ Ibanda",
  city: "Bukavu",
  country: "RD Congo",
  rccm: "CK/BKV/RCCM/20-B-00095",
  taxNo: "A2046785B",
  idNat: "22-J6100-N70836G",
  duns: "851754060",
  phone: "+243 97 326 0160",
  phoneHref: "tel:+243973260160",
  whatsappHref: "https://wa.me/243973260160",
  email: "info@oxide-digital.com",
  website: "www.oxide-digital.com",
};
